export const madinaty = {
  landmarks: [
    "بوابات مدينتي",
    "طريق السويس الصحراوي",
    "الأوبن إير مول",
    "الساوث بارك",
    "السنترال بارك",
    "ميدان الساعة",
    "أرابسيك مول"
  ],
  title: "ونش انقاذ مدينتي | خدمة VIP داخل مدينتي وطريق السويس",
  metaDescription: "ونش انقاذ سيارات في مدينتي. نقدم خدمة راقية وفورية لسحب السيارات من أمام الأوبن إير مول، الساوث بارك، وطريق السويس بأحدث الأوناش وبأسعار ممتازة.",
  intro: `مدينتي ليست مجرد مجمع سكني، بل هي مجتمع متكامل وراقي يتطلب خدمات بمستوى يضاهي جودة الحياة فيه. سواء كنت تتسوق في الأوبن إير مول، أو تتنزه في السنترال بارك، أو حتى على طريق السويس عائداً إلى منزلك، فإن تعرض سيارتك لعطل طارئ يحتاج إلى استجابة سريعة من ونش انقاذ محترف وموثوق.
  نحن نوفر خدمة ونش انقاذ مدينتي المخصصة لسكان وزوار المدينة. أسطولنا من سيارات الإنقاذ الحديثة مسموح له بالدخول السلس عبر البوابات لتقديم الخدمة مباشرة أمام منزلك أو في مواقع التسوق. نحن نضمن لك تجربة إنقاذ مريحة، خالية من التوتر، وتحافظ على سيارتك في أمان تام.`,
  highlights: [
    "سهولة وسرعة الوصول عبر بوابات مدينتي لإنقاذ السيارات من الداخل",
    "خدمة VIP مخصصة للسيارات الفارهة والعائلية باستخدام أوناش مسطحة حديثة",
    "تغطية فورية لطريق السويس أمام بوابات مدينتي",
    "فريق عمل مدرب على أعلى مستوى للتعامل الراقي مع سكان مدينتي"
  ],
  safetyTips: [
    "إذا تعطلت داخل مدينتي (مثل الساوث بارك أو الأوبن إير مول)، قم بركن السيارة بعيداً عن مسارات عربات الجولف والمشاة لتسهيل وصول الونش.",
    "على طريق السويس أمام مدينتي، استخدم حارة الطوارئ فوراً وضع علامات التحذير، وتجنب الوقوف في مسار السيارات السريعة.",
    "قم بإرسال موقعك بدقة (Location) لموظف خدمة العملاء لضمان وصول الونش للزون (Zone) الخاص بك دون تأخير."
  ],
  faqs: [
    {
      q: "هل ونش الإنقاذ مصرح له بالدخول عبر بوابات مدينتي لسحب سيارتي من أمام المنزل؟",
      a: "نعم، أوناشنا لديها تصاريح دخول للتعامل مع طوارئ السيارات داخل مدينتي، وسائقونا على دراية تامة بتقسيم المناطق (Zones) لسهولة الوصول إليك."
    },
    {
      q: "سيارتي فارهة ومنخفضة جداً، هل الونش آمن لرفعها دون خدوش؟",
      a: "بالتأكيد، نحن نستخدم أحدث أوناش السطحة الهيدروليكية (Flatbed) التي تنزل بزاوية مسطحة تماماً لتأمين السيارات الرياضية والفارهة بشكل كامل."
    },
    {
      q: "نسيت مفتاح السيارة بداخلها وهي مقفلة في الأوبن إير مول، هل يمكنكم فتحها؟",
      a: "نعم، فرقنا مزودة بمعدات حديثة لفتح السيارات المغلقة باحترافية شديدة ودون إلحاق أي ضرر بزجاج أو طلاء السيارة."
    },
    {
      q: "كم يستغرق ونش الإنقاذ للوصول إلى طريق السويس أمام بوابات مدينتي؟",
      a: "لدينا وحدات إنقاذ متمركزة بصفة دائمة بالقرب من بوابات مدينتي وعلى طريق السويس، مما يجعل وقت استجابتنا لا يتجاوز 15 دقيقة في المتوسط."
    }
  ],
  seoText: `
    <h2>خدمة ونش انقاذ سيارات مميزة في مدينتي</h2>
    <p>يعتمد سكان مدينتي على سياراتهم بشكل أساسي للتنقل سواء داخل مجتمعاتهم السكنية (الزونز) أو للتنقل إلى قلب القاهرة عبر طريق السويس. ولأن الأعطال المفاجئة لا تفرق بين سيارة جديدة أو قديمة، فإن توفر خدمة ونش انقاذ مدينتي أصبح ضرورة قصوى. نحن نقدم هذه الخدمة بمعايير الجودة التي يتوقعها السكان، مع التركيز على الأمان والسرعة والاحترافية.</p>

    <h3>العناية بسيارات سكان مدينتي</h3>
    <p>نحن نتفهم قيمة السيارات التي يمتلكها سكان مدينتي، ولذلك فإن أسطولنا يتكون من أوناش السطحة المتطورة. هذه الأوناش ترفع السيارة بالكامل وتثبتها بعناية فائقة، مما يحافظ على العفشة وأنظمة الدفع الرباعي والمحركات الحديثة من أي أضرار قد تنتج عن السحب التقليدي المتهالك.</p>

    <h3>تغطية طريق السويس وامتداداته</h3>
    <p>لا تقتصر خدماتنا على الداخل فقط، بل نؤمن محيط مدينتي بالكامل على طريق السويس. نحن جزء من شبكة تغطية متكاملة لمدن التجمع وشرق القاهرة. فإذا كنت في طريقك للقاهرة، ستجد فرق <a href="/areas/الرحاب">ونش انقاذ الرحاب</a> و <a href="/areas/التجمع الأول">ونش انقاذ التجمع الأول</a> مستعدة لتقديم الدعم إذا لزم الأمر، لضمان وصولك ومركبتك بسلام لأي وجهة تقصدها.</p>
    <p>احفظ رقم طوارئ الإنقاذ الخاص بنا، واعتمد علينا لتقديم أفضل خدمة في مدينتي على مدار 24 ساعة.</p>
  `
};
